var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "03 Login"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.25 276H162.46a20 20 0 0 1 0-40h221.79a20 20 0 0 1 0 40z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.16 371.69a19.93 19.93 0 0 1-14.16-5.85l-85-85a35.18 35.18 0 0 1 0-49.68l85-85a20 20 0 1 1 28.28 28.29L149.75 256l81.55 81.55a20 20 0 0 1-14.14 34.14z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410 512H102A102.12 102.12 0 0 1 0 410V102A102.12 102.12 0 0 1 102 0h308a102.12 102.12 0 0 1 102 102v308a102.12 102.12 0 0 1-102 102zM102 40a62.07 62.07 0 0 0-62 62v308a62.07 62.07 0 0 0 62 62h308a62.07 62.07 0 0 0 62-62V102a62.07 62.07 0 0 0-62-62z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.b9ef01d1bdc98f9240d20282c2234c0f.svg";
export { ForwardRef as ReactComponent };